import jsonSKY from './wonderwall-project-SKY.json';
import jsonDGO from './wonderwall-project-DGO.json';
import { APP_THEME, isCustomSkinActive } from '../utils/env';

export function getJsonImage(imageName) {
  if (isCustomSkinActive) {
    const theme = APP_THEME;
    const json = theme === 'skymais' ? jsonSKY : jsonDGO; // DGO default
    return json.images[imageName];
  }
  return undefined;
}

// Images that are directly on SCSS
function setSCSSVariablesFromJSON() {
  if (isCustomSkinActive) {
    const theme = APP_THEME;
    const json = theme === 'skymais' ? jsonSKY : jsonDGO; // DGO default
    const root = document.documentElement;

    // TODO substituir imagens no SCSS com flag
    // list of images that are imported directly on SCSS
    const desiredImages = [
      '16-9',
    ];

    for (const imageName of desiredImages) {
      if (json.images[imageName]) {
        root.style.setProperty(`--image-${imageName}`, `url(${json.images[imageName]})`);
      }
    }
  }
}

setSCSSVariablesFromJSON();
